import styled from '@emotion/styled';
import { tokens } from '@hotjar/hotsauce';

export const Header = styled.span`
  font-style: normal;
  font-weight: 600;
  font-size: 12px;
  line-height: 150%;
  letter-spacing: 0.4px;
  text-transform: uppercase;
  color: ${tokens.color.text_default};
`;

export const ContentSection = styled.div`
  padding: 0px 0px ${tokens.spacer.x1} 0px;
`;

export const SwitchLink = styled.div<{ variant: string }>`
  margin: 5px 20px 0 0;
  text-decoration: underline;
  cursor: pointer;
  color: ${(props) =>
    props.variant === 'primary' ? tokens.color.cobalt_800 : tokens.color.neutral_500};
  font-weight: 600;
  font-size: 12px;
  line-height: 150%;
  letter-spacing: 0.1px;
`;

export const ErrorInfoTitle = styled.span`
  width: 100%;
  color: ${tokens.color.text_danger};
  font-weight: bold;
  line-height: 150%;
  align-items: center;
  letter-spacing: 0.1px;
  padding-bottom: ${tokens.spacer.x1};
`;

export const ErrorInfoContent = styled.span`
  width: 100%;
  color: ${tokens.color.text_default};
  display: block;
  font-size: 12px;
  line-height: 140%;
  letter-spacing: 0.1px;
  padding: ${tokens.spacer.x1} 0;
`;
